import './index.css';



// WEBPACK FOOTER //
// ./ecology9/wea-image-cropper/style/index.js